import { BlogMetadata, IArticle } from '@models/article.interface';
import { IAuthorBase } from '@models/author.interface';
import { convert } from 'html-to-text';
import parse from 'html-react-parser';

export const noIndexArticlesSlugs: string[] = [
  'agilie-at-cmocs-2016',
  'agilies-ceo-sergey-gladun-is-among-the-three-finalists-for-the-ceo-of-the-year-at-it-biz-awards-2016',
  'agilies-football-team-becomes-the-absolute-champions-of-the-dnipro-football-it-league-autumn-season-2016',
  'agilie-design-the-year-2016-in-animations',
];

export function articleAuthor(article: IArticle): Required<IAuthorBase> {
  // TODO: Add Memoization here
  const DEFAULT_NAME = 'John Doe';
  const DEFAULT_AVATAR = '/assets/defaults/author.png';

  const author = article.authors?.[0]?.author;
  return {
    name: author?.name || DEFAULT_NAME,
    avatarUrl: author?.avatarUrl || DEFAULT_AVATAR,
    slug: author?.slug || '',
    position: author?.position,
  };
}

const IMG_RGX = /<img.+?src=['"](.+?)['"].+?\/>/g;

export function imageSrcReplacer(content: string): string {
  const subs = content.match(IMG_RGX);
  if (!subs) {
    return content;
  }
  for (const img of subs) {
    const src = img.match(/src=['"](.+?)['"]/);
    if (!src || !src[1]) {
      continue;
    }
    const imageProxyUrl = `/api/imageproxy?url=${encodeURIComponent(src[1])}`;

    const srcUrl = `/_next/image?url=${imageProxyUrl}&w=1920&q=75`;
    // TODO: Add srcset for the future
    const newImage = img.replace(src[0], `src="${srcUrl}"`);
    if (src) {
      content = content.replace(img, newImage);
    }
  }
  return content;
}

// Example
// <img alt="How to Create a Language Learning App Like Duolingo?"
// src="/_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=3840&amp;q=75" decoding="async" data-nimg="fill"
// style="position:absolute;top:0;left:0;bottom:0;right:0;box-sizing:border-box;padding:0;border:none;margin:auto;display:block;width:0;height:0;min-width:100%;max-width:100%;min-height:100%;max-height:100%" sizes="400px"
// srcset="/_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=16&amp;q=75 16w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=32&amp;q=75 32w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=48&amp;q=75 48w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=64&amp;q=75 64w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=96&amp;q=75 96w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=128&amp;q=75 128w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=256&amp;q=75 256w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=384&amp;q=75 384w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=640&amp;q=75 640w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=750&amp;q=75 750w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=828&amp;q=75 828w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=1080&amp;q=75 1080w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=1200&amp;q=75 1200w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=1920&amp;q=75 1920w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=2048&amp;q=75 2048w, /_next/image?url=https%3A%2F%2Fd12zh9bqbty5wp.cloudfront.net%2Fuploads%2Fblog_article_avatars%2F08680fa6b3b945c282a0e6c8b50fef4a4a9ebeed.jpg&amp;w=3840&amp;q=75 3840w">

export function getParsedTextFromHTML(html: string): string {
  const removeBreaklinesRegexp = new RegExp(/\s+/g);
  const parsed = convert(html);
  return parsed.replace(removeBreaklinesRegexp, ' ');
}

export function getImagesSourceFromHTML(html: string): string[] {
  const regex: RegExp = new RegExp('<img.*?src=[\'"](.*?)[\'"]', 'gi');
  const matches: RegExpMatchArray[] = Array.from(html.matchAll(regex));
  return matches.map(([image, src]) => src) || [];
}

export function isInternalArticleLink(href: string): boolean {
  try {
    return href.startsWith('/') || href.includes('agilie.com') || new URL(href).hostname.includes('agilie');
  } catch {
    // blog/some-article -> ['blog', 'some-article']
    const [hostOrInternalModule] = href.split('/');
    // if it does not include '.', then link is internal
    // i.e. netflix.com (without protocol) return false
    return !hostOrInternalModule.includes('.');
  }
}

export function getNoIndexMetaTag(slug: string): string | JSX.Element | JSX.Element[] {
  if (noIndexArticlesSlugs.includes(slug)) {
    return parse(`<meta name="robots" content="noindex" />`);
  }

  return '';
}

export const toPaginatedMetaText = (page: number, isTitle: boolean = true): string => {
  const isFirstPage: boolean = page === 1;

  if (isFirstPage) {
    return '';
  }

  if (isTitle) {
    return `| Page ${page} `;
  }

  // meta description
  return ` (Page ${page})`;
};

export const BLOG_TOPIC_METADATA: Record<string, BlogMetadata> = {
  public: {
    h1: 'Exploring software development',
    title: (page: number) => `Public Sector Technology Blog ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Discover how technology is transforming the public sector. Learn about the latest trends, challenges, and innovations in public sector tech. ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  default: {
    h1: 'Exploring software development',
    title: (page: number) => `Blog about web and mobile development, UX design ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Blog about web and mobile development, UX design${toPaginatedMetaText(
        page,
        false,
      )}. Ideas and thoughts. Welcome!`,
  },
  design: {
    h1: 'Exploring UX & web design',
    title: (page: number) => `Articles on UX and Web Design ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Visit Agilie's blog page dedicated to UX and web design${toPaginatedMetaText(
        page,
        false,
      )}. Browse our collection of articles offering the latest trends, tips, and expert advice to enhance your design strategy.`,
  },
  development: {
    h1: 'Exploring engineering practices',
    title: (page: number) => `Software Development Blog ${toPaginatedMetaText(page)}`,
    description: (page: number) =>
      `Stay current with the latest trends and best practices in software development. Get tips and insights from industry experts. ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  'QA/QC': {
    h1: 'Exploring QA & testing',
    title: (page: number) => `Quality Assurance & Quality Control Blog ${toPaginatedMetaText(page)}`,
    description: (page: number) =>
      `Explore best practices and expert advice on quality assurance and quality control. Learn how to ensure your software meets the highest standards. ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  insights: {
    h1: 'Exploring DevOps & compliance',
    title: (page: number) => `Articles on Tech Insights ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Visit Agilie's blog page dedicated to tech insights${toPaginatedMetaText(
        page,
        false,
      )}. Browse our collection of articles offering the latest trends, tips, and expert advice to enhance your understanding of the tech industry.`,
  },
  fintech: {
    h1: 'Exploring fintech solutions',
    title: (page: number) => `Fintech Innovation Blog  ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Discover the future of financial technology with our in-depth articles. Explore trends, challenges, and solutions shaping the fintech landscape ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  healthcare: {
    h1: 'Exploring healthcare tech',
    title: (page: number) => `Healthcare Technology Blog ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Stay informed about the latest advancements in healthcare technology. Learn how digital solutions are transforming the healthcare industry. ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  HoReCa: {
    h1: 'Exploring HoReCa tech',
    title: (page: number) => `HoReCa Technology Blog ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Discover how technology is transforming the hospitality industry. Read about the latest innovations and trends in the HoReCa sector. ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  AI: {
    h1: 'Exploring AI development',
    title: (page: number) => `Artificial Intelligence Blog ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Uncover the potential of artificial intelligence. Learn about AI trends, applications, and how AI is revolutionizing various industries. ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  blockchain: {
    h1: 'Exploring blockchain tech',
    title: (page: number) => `Articles on Blockchain ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Visit Agilie's blog page dedicated to blockchain technology${toPaginatedMetaText(
        page,
        false,
      )}. Browse our collection of articles offering the latest trends, tips, and expert advice to enhance your understanding of blockchain.`,
  },
  'E-commerce': {
    h1: 'Exploring e-commerce dev',
    title: (page: number) => `E-commerce Solutions Blog ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Get expert insights on e-commerce trends, strategies, and technologies. Discover how to build and optimize successful online stores. ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  geolocation: {
    h1: 'Exploring geolocation tech',
    title: (page: number) => `Geolocation Technology Blog ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Dive into the world of geolocation technology. Learn about the latest developments, use cases, and best practices for integrating geolocation in your projects ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  other: {
    h1: 'Exploring next-gen software',
    title: (page: number) => `Other Tech Related Articles ${toPaginatedMetaText(page)}| Agilie`,
    description: (page: number) =>
      `Explore a wide range of tech topics, from emerging technologies to industry best practices. Stay ahead with our expert articles ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
  news: {
    h1: "Agilie's NEWSROOM",
    title: (page: number) =>
      `Agilie Official News | Highlights & Corporate Press Releases ${toPaginatedMetaText(page)}`,
    description: (page: number) =>
      `Stay updated with Agilie’s official news. Discover our latest software development projects, tech breakthroughs, milestones, and team achievements ${toPaginatedMetaText(
        page,
        false,
      )}.`,
  },
};
